import './Search.scss'

import {FilterOutlined} from '@ant-design/icons'
import {Button, Col, Collapse, Form, Modal, notification, Pagination, Row, TreeDataNode} from 'antd'
import TextArea from "antd/lib/input/TextArea";
import {OkulYonetimUrunFiltre, useOkulyonetimrunlerQuery} from 'gql/GeneratedGraphqlTypes'
import React, {useContext, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'

import AppContext from '../../../context/AppContext'
import useMediaQuery from '../../../hooks/useMediaQuery'
import {DEV_BACKEND_DOMAIN} from "../../../utils/const";
import Spinner from '../../spinner/Spinner'
import OkulyonetimAlert from '../okulyonetim-alert/OkulyonetimAlert'
import OkulyonetimCategoryFilter from '../okulyonetim-filters/okulyonetim-category-filter/OkulyonetimCategoryFilter'
import OkulyonetimDersFilter from '../okulyonetim-filters/okulyonetim-ders-filter/OkulyonetimDersFilter'
import OkulyonetimOtherFilter from '../okulyonetim-filters/okulyonetim-other-filter/OkulyonetimOtherFilter'
import OkulyonetimSearchFilter from '../okulyonetim-filters/okulyonetim-search-filter/OkulyonetimSearchFilter'
import OkulyonetimSinifFilter from '../okulyonetim-filters/okulyonetim-sinif-filter/OkulyonetimSinifFilter'
import OkulyonetimProduct from '../okulyonetim-product/OkulyonetimProduct'
import {CustomTreeDataNode} from '../okulyonetim-product-list/OkulyonetimProductList'

const Search: React.FC = () => {
    const location = useLocation()
    const query = new URLSearchParams(location.search).get('query') || ''
    const queryKategori = new URLSearchParams(location.search).get('queryKategori') || ''
    const queryYayinevi = new URLSearchParams(location.search).get('queryYayinevi') || ''
    const querySinif = new URLSearchParams(location.search).get('querySinif') || ''
    const [currentPage, setCurrentPage] = React.useState<number>(0)
    const {slug, token,email} = useContext(AppContext)
    const isMobile = useMediaQuery(992)
    const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]) // Seçili kategorilerin anahtarları
    const [checkedYayineviKeys, setCheckedYayineviKeys] = useState<React.Key[]>([]) // Seçili yayınevlerinin anahtarları
    const [checkedSinifKeys, setCheckedSinifKeys] = useState<React.Key[]>([]) // Seçili sınıfların anahtarları
    const [checkedDersKeys, setCheckedDersKeys] = useState<React.Key[]>([]) // Seçili derslerin anahtarları
    const [open, setOpen] = useState(false)
    const [form] = Form.useForm()
    const [filters, setFilters] = useState<OkulYonetimUrunFiltre>({
        kategori_slug: [], // Kategori filtresi sıfırlanıyor
        yayinevi_slug: [], // Yayinevi filtresi sıfırlanıyor
        ders_slug: [], // Ders filtresi sıfırlanıyor
        sinif_slug: [], // Sınıf filtresi sıfırlanıyor
        arama: query,
        sayfa: currentPage,
    })
    const {data, error, loading: queryLoading, refetch} = useOkulyonetimrunlerQuery({
        variables: {
            filtre: filters,
            slug: slug!,
        },
    })

    useEffect(() => {
        const updatedFilters = {
            ...filters,
            arama: query,
            kategori_slug: queryKategori ? [queryKategori] : [],
            yayinevi_slug: queryYayinevi ? [queryYayinevi] : [],
            sinif_slug: querySinif ? [querySinif] : [],
            sayfa: 0,
        }

        setFilters(updatedFilters)
        setCurrentPage(1)
        refetch({
            filtre: updatedFilters,
            slug: slug!,
        })
        if (queryKategori) setCheckedKeys([queryKategori])
        if (queryYayinevi) setCheckedYayineviKeys([queryYayinevi])
        if (querySinif) setCheckedSinifKeys([querySinif])
    }, [query, refetch, slug])
    const handlePageChange = (page: number) => {
        setCurrentPage(page)
        setFilters((prevFilters) => ({
            ...prevFilters,
            sayfa: page - 1,
        }))
    }
    if (queryLoading) {
        return <Spinner showSpinner={true} color="red" />
    }

    if (error) return <div>Hata: {error.message}</div>

    const buildCategoryTree = (categories: any[]): CustomTreeDataNode[] => {
        const categoryMap: { [key: string]: CustomTreeDataNode } = {}
        const tree: CustomTreeDataNode[] = []

        // Kategorileri harita içine ekle
        categories.forEach((category) => {
            const node: CustomTreeDataNode = {
                key: category.kategori_slug,
                title: category.isim || 'Bilinmeyen Kategori',
                children: [],
            }
            categoryMap[category.kategori_slug] = node

            if (!category.parent_slug) {
                tree.push(node)
            }
        })

        // Alt kategorileri ebeveyn kategorilere bağla
        categories.forEach((category) => {
            if (category.alt_kategoriler && category.alt_kategoriler.length > 0) {
                category.alt_kategoriler.forEach((subCategory: any, index: number) => {
                    const uniqueKey = `${subCategory.alt_kategori_slug}*${index}` // Benzersiz key

                    const childNode: CustomTreeDataNode = {
                        key: uniqueKey,
                        title: subCategory.isim,
                        parentKey: category.kategori_slug, // Üst kategorinin key'i
                        children: [],
                    }

                    // Alt kategoriyi ebeveynine bağla
                    if (categoryMap[category.kategori_slug]) {
                        categoryMap[category.kategori_slug]?.children?.push(childNode)
                    }
                })
            }
        })

        return tree
    }
    const formatTreeData = (): TreeDataNode[] => {
        const categories = [...(data?.okul?.okulyonetimUrunler?.kategoriler || [])] // `readonly` özelliğini kaldırır
        return buildCategoryTree(categories)
    }
    const isAnyFilterActive = () => {
        // Filtrelerden herhangi biri doluysa true döner
        return (
            filters?.kategori_slug?.length! > 0 ||
            filters?.alt_kategori_slug?.length! > 0 ||
            filters?.yayinevi_slug?.length! > 0 ||
            filters?.ders_slug?.length! > 0 ||
            filters?.sinif_slug?.length! > 0
        )
    }

    const modalHandleCancel = async () => {
        setOpen(false)
        form.resetFields()
    }
    const modalOnOk = async () => {
        try {
            const values = await form.validateFields(); // Form doğrulama
            setOpen(false); // Modal kapat
            form.resetFields();
            const url = `https://${slug}.${DEV_BACKEND_DOMAIN}/urun-bulunamadi/${token}/?title=${encodeURIComponent(values.title ? values.title : '')}&description=${encodeURIComponent(values.description)}&mail=${email}`;
            fetch(url)
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        notification.success({
                            message: 'Talebiniz başarıyla iletilmiştir. En kısa sürede giriş yaptığınız mail adresinize dönüş yapılacaktır.',
                            duration: 6,
                        })
                    } else {
                        notification.success({
                            message: data.error || "Bir hata oluştu.",
                            duration: 6,
                        })
                    }
                })
                .catch(() => {
                    notification.success({
                        message: "Mail gönderimi sırasında bir hata oluştu.",
                        duration: 6,
                    })
                });

        } catch (errorInfo) {
            console.error("Doğrulama hatası:", errorInfo);
        }
    };

    return (
        <div className="okulyonetim-product-list">
            <OkulyonetimAlert/>
            <Row gutter={[24, 24]}>
                <Col xs={24} lg={6}>
                    {isAnyFilterActive() && (
                        <div className="okulyonetim-product-list-filter-clean">
                            <Button
                                danger
                                className="clear-filters-button"
                                onClick={() => {
                                    // Tüm filtreleri temizle
                                    setFilters({
                                        arama: '',
                                        kategori_slug: [],
                                        yayinevi_slug: [],
                                        ders_slug: [],
                                        sinif_slug: [],
                                        sayfa: 0,
                                    })
                                    setCheckedKeys([])
                                    setCheckedYayineviKeys([])
                                    setCheckedSinifKeys([])
                                    setCheckedDersKeys([])
                                    setCurrentPage(1)
                                }}
                            >
                                Filtreyi Temizle
                            </Button>
                        </div>
                    )}
                    {isMobile ? (
                        <div className="okulyonetim-product-list-filter">
                            <Collapse
                                size="large"
                                expandIcon={() => (
                                    <div className="okulyonetim-product-list-filter-icon">
                                        <FilterOutlined/>
                                    </div>
                                )}
                            >
                                <Collapse.Panel key={1} header={'Filtrele'}>
                                    {query && <OkulyonetimSearchFilter searchValue={query}/>}
                                    <OkulyonetimCategoryFilter
                                        treeData={formatTreeData() as CustomTreeDataNode[]}
                                        checkedKeys={checkedKeys} // Seçili kategoriler
                                        onCheck={(updatedCheckedKeys, info) => {
                                            // Mevcut kategori ve alt kategori sluglarını koru
                                            let kategoriSluglar: string[] = Array.isArray(filters?.kategori_slug)
                                                ? [...(filters.kategori_slug as string[])]
                                                : []
                                            let altKategoriSluglar: string[] = Array.isArray(filters?.alt_kategori_slug)
                                                ? [...(filters.alt_kategori_slug as string[])]
                                                : []

                                            if (info.checked) {
                                                // Eğer filtre ekleniyorsa
                                                if (info.node.children && info.node.children.length > 0) {
                                                    // Ana kategori seçilmişse
                                                    const selectedKategoriSluglar = updatedCheckedKeys.filter(
                                                        (key) => key === info.node.key,
                                                    ) as string[]

                                                    kategoriSluglar = Array.from(new Set([...kategoriSluglar, ...selectedKategoriSluglar]))

                                                    const childKeys = info.node.children.map((child: any) => {
                                                        const key = child.key.split('*')[0]
                                                        return key
                                                    })

                                                    altKategoriSluglar = Array.from(new Set([...altKategoriSluglar, ...childKeys]))
                                                } else {
                                                    // Alt kategori seçilmişse
                                                    const selectedAltKategoriSluglar = updatedCheckedKeys.map((key) => {
                                                        if (typeof key === 'string') {
                                                            const splitKey = key.split('*')[0]
                                                            return splitKey
                                                        }
                                                        return ''
                                                    })

                                                    altKategoriSluglar = Array.from(
                                                        new Set([...altKategoriSluglar, ...selectedAltKategoriSluglar]),
                                                    )

                                                    if (info.node.parentKey) {
                                                        kategoriSluglar = Array.from(new Set([...kategoriSluglar, info.node.parentKey]))
                                                    }
                                                }
                                            } else {
                                                // Eğer filtre kaldırılıyorsa
                                                if (info.node.children && info.node.children.length > 0) {
                                                    // Ana kategori kaldırılmışsa
                                                    kategoriSluglar = kategoriSluglar.filter((slug) => slug !== info.node.key)

                                                    const childKeys = info.node.children.map((child: any) => {
                                                        const key = child.key.split('*')[0]
                                                        return key
                                                    })

                                                    altKategoriSluglar = altKategoriSluglar.filter((slug) => !childKeys.includes(slug))
                                                } else {
                                                    // Alt kategori kaldırılmışsa
                                                    const removedAltKategoriSlug = info.node.key.split('*')[0]
                                                    altKategoriSluglar = altKategoriSluglar.filter((slug) => slug !== removedAltKategoriSlug)

                                                    if (info.node.parentKey) {
                                                        const parentSlug = info.node.parentKey
                                                        const isParentStillSelected = updatedCheckedKeys.includes(parentSlug)
                                                        if (!isParentStillSelected) {
                                                            kategoriSluglar = kategoriSluglar.filter((slug) => slug !== parentSlug)
                                                        }
                                                    }
                                                }
                                            }

                                            // Filtreleri güncelle
                                            setCurrentPage(1)
                                            setFilters((prevFilters) => ({
                                                ...prevFilters,
                                                kategori_slug: Array.from(new Set([...kategoriSluglar])),
                                                alt_kategori_slug: Array.from(new Set([...altKategoriSluglar])),
                                                sayfa: 0,
                                            }))

                                            setCheckedKeys(updatedCheckedKeys)
                                        }}
                                    />
                                    <OkulyonetimOtherFilter
                                        title="Yayınevleri"
                                        searchbar
                                        checkedTempKeys={checkedYayineviKeys.map((key) => key.toString())}
                                        options={
                                            data?.okul?.okulyonetimUrunler?.yayinevleri
                                                ?.filter((yayinevi) => yayinevi !== null && yayinevi?.yayinevi_count > 0)
                                                ?.map((yayinevi) => ({
                                                    title: yayinevi?.isim || 'Bilinmeyen',
                                                    count: yayinevi?.yayinevi_count,
                                                    value: yayinevi?.yayinevi_slug || '', // Null değerlerden kaçının
                                                    isSelected: yayinevi?.isSelected,
                                                })) || []
                                        }
                                        onChange={(selectedYayineviSlugs) => {
                                            setCurrentPage(1)
                                            setFilters((prevFilters) => {
                                                // Mevcut slug değerlerini al
                                                const currentSlugs = prevFilters.yayinevi_slug || []

                                                // Gelen slug değerlerini kontrol et ve güncelle
                                                const updatedSlugs = selectedYayineviSlugs.reduce((acc, slug) => {
                                                    if (currentSlugs.includes(slug)) {
                                                        // Eğer mevcutta varsa, çıkar
                                                        return acc.filter((existingSlug) => existingSlug !== slug)
                                                    } else {
                                                        // Eğer mevcutta yoksa, ekle
                                                        return [...acc, slug]
                                                    }
                                                }, currentSlugs)
                                                setCheckedYayineviKeys(updatedSlugs as React.Key[])
                                                return {
                                                    ...prevFilters,
                                                    yayinevi_slug: updatedSlugs,
                                                    sayfa: 0,
                                                }
                                            })
                                        }}
                                    />
                                    <OkulyonetimSinifFilter
                                        title="Sınıf Seviyesi"
                                        searchbar={false}
                                        checkedTempKeys={checkedSinifKeys.map((key) => key.toString())}
                                        options={
                                            data?.okul?.okulyonetimUrunler?.siniflar
                                                ?.filter((sinif) => sinif !== null && sinif?.sinif_count > 0)
                                                ?.map((sinif) => ({
                                                    title: sinif?.isim || 'Bilinmeyen',
                                                    count: sinif?.sinif_count,
                                                    value: sinif?.sinif_slug || '', // Null değerlerden kaçının
                                                    isSelected: false,
                                                })) || []
                                        }
                                        onChange={(selectedSinifSlugs) => {
                                            setCurrentPage(1)
                                            setFilters((prevFilters) => {
                                                // Mevcut slug değerlerini al
                                                const currentSlugs = prevFilters.yayinevi_slug || []

                                                // Gelen slug değerlerini kontrol et ve güncelle
                                                const updatedSlugs = selectedSinifSlugs.reduce((acc, slug) => {
                                                    if (currentSlugs.includes(slug)) {
                                                        // Eğer mevcutta varsa, çıkar
                                                        return acc.filter((existingSlug) => existingSlug !== slug)
                                                    } else {
                                                        // Eğer mevcutta yoksa, ekle
                                                        return [...acc, slug]
                                                    }
                                                }, currentSlugs)
                                                setCheckedSinifKeys(updatedSlugs as React.Key[])
                                                return {
                                                    ...prevFilters,
                                                    sinif_slug: updatedSlugs,
                                                    sayfa: 0,
                                                }
                                            })
                                        }}
                                    />
                                    <OkulyonetimDersFilter
                                        title="Ders"
                                        searchbar={false}
                                        checkedTempKeys={checkedDersKeys.map((key) => key.toString())}
                                        options={
                                            data?.okul?.okulyonetimUrunler?.dersler
                                                ?.filter((ders) => ders !== null && ders?.ders_count > 0)
                                                ?.map((ders) => ({
                                                    title: ders?.isim || 'Bilinmeyen',
                                                    count: ders?.ders_count,
                                                    value: ders?.ders_slug || '', // Null değerlerden kaçının
                                                    isSelected: false,
                                                })) || []
                                        }
                                        onChange={(selectedDersSlugs) => {
                                            setCurrentPage(1)
                                            setFilters((prevFilters) => {
                                                // Mevcut slug değerlerini al
                                                const currentSlugs = prevFilters.yayinevi_slug || []

                                                // Gelen slug değerlerini kontrol et ve güncelle
                                                const updatedSlugs = selectedDersSlugs.reduce((acc, slug) => {
                                                    if (currentSlugs.includes(slug)) {
                                                        // Eğer mevcutta varsa, çıkar
                                                        return acc.filter((existingSlug) => existingSlug !== slug)
                                                    } else {
                                                        // Eğer mevcutta yoksa, ekle
                                                        return [...acc, slug]
                                                    }
                                                }, currentSlugs)
                                                setCheckedDersKeys(updatedSlugs as React.Key[])
                                                return {
                                                    ...prevFilters,
                                                    ders_slug: updatedSlugs,
                                                    sayfa: 0,
                                                }
                                            })
                                        }}
                                    />
                                </Collapse.Panel>
                            </Collapse>
                        </div>
                    ) : (
                        <div>
                            {query && <OkulyonetimSearchFilter searchValue={query}/>}
                            <OkulyonetimCategoryFilter
                                treeData={formatTreeData() as CustomTreeDataNode[]}
                                checkedKeys={checkedKeys} // Seçili kategoriler
                                onCheck={(updatedCheckedKeys, info) => {
                                    // Mevcut kategori ve alt kategori sluglarını koru
                                    let kategoriSluglar: string[] = Array.isArray(filters?.kategori_slug)
                                        ? [...(filters.kategori_slug as string[])]
                                        : []
                                    let altKategoriSluglar: string[] = Array.isArray(filters?.alt_kategori_slug)
                                        ? [...(filters.alt_kategori_slug as string[])]
                                        : []

                                    if (info.checked) {
                                        // Eğer filtre ekleniyorsa
                                        if (info.node.children && info.node.children.length > 0) {
                                            // Ana kategori seçilmişse
                                            const selectedKategoriSluglar = updatedCheckedKeys.filter(
                                                (key) => key === info.node.key,
                                            ) as string[]

                                            kategoriSluglar = Array.from(new Set([...kategoriSluglar, ...selectedKategoriSluglar]))

                                            const childKeys = info.node.children.map((child: any) => {
                                                const key = child.key.split('*')[0]
                                                return key
                                            })

                                            altKategoriSluglar = Array.from(new Set([...altKategoriSluglar, ...childKeys]))
                                        } else {
                                            // Alt kategori seçilmişse
                                            const selectedAltKategoriSluglar = updatedCheckedKeys.map((key) => {
                                                if (typeof key === 'string') {
                                                    const splitKey = key.split('*')[0]
                                                    return splitKey
                                                }
                                                return ''
                                            })

                                            altKategoriSluglar = Array.from(new Set([...altKategoriSluglar, ...selectedAltKategoriSluglar]))

                                            if (info.node.parentKey) {
                                                kategoriSluglar = Array.from(new Set([...kategoriSluglar, info.node.parentKey]))
                                            }
                                        }
                                    } else {
                                        // Eğer filtre kaldırılıyorsa
                                        if (info.node.children && info.node.children.length > 0) {
                                            // Ana kategori kaldırılmışsa
                                            kategoriSluglar = kategoriSluglar.filter((slug) => slug !== info.node.key)

                                            const childKeys = info.node.children.map((child: any) => {
                                                const key = child.key.split('*')[0]
                                                return key
                                            })

                                            altKategoriSluglar = altKategoriSluglar.filter((slug) => !childKeys.includes(slug))
                                        } else {
                                            // Alt kategori kaldırılmışsa
                                            const removedAltKategoriSlug = info.node.key.split('*')[0]
                                            altKategoriSluglar = altKategoriSluglar.filter((slug) => slug !== removedAltKategoriSlug)

                                            if (info.node.parentKey) {
                                                const parentSlug = info.node.parentKey
                                                const isParentStillSelected = updatedCheckedKeys.includes(parentSlug)
                                                if (!isParentStillSelected) {
                                                    kategoriSluglar = kategoriSluglar.filter((slug) => slug !== parentSlug)
                                                }
                                            }
                                        }
                                    }

                                    // Filtreleri güncelle
                                    setCurrentPage(1)
                                    setFilters((prevFilters) => ({
                                        ...prevFilters,
                                        kategori_slug: Array.from(new Set([...kategoriSluglar])),
                                        alt_kategori_slug: Array.from(new Set([...altKategoriSluglar])),
                                        sayfa: 0,
                                    }))

                                    setCheckedKeys(updatedCheckedKeys)
                                }}
                            />
                            <OkulyonetimOtherFilter
                                title="Yayınevleri"
                                searchbar
                                checkedTempKeys={checkedYayineviKeys.map((key) => key.toString())}
                                options={
                                    data?.okul?.okulyonetimUrunler?.yayinevleri
                                        ?.filter((yayinevi) => yayinevi !== null && yayinevi?.yayinevi_count > 0)
                                        ?.map((yayinevi) => ({
                                            title: yayinevi?.isim || 'Bilinmeyen',
                                            count: yayinevi?.yayinevi_count,
                                            value: yayinevi?.yayinevi_slug || '', // Null değerlerden kaçının
                                            isSelected: yayinevi?.isSelected,
                                        })) || []
                                }
                                onChange={(selectedYayineviSlugs) => {
                                    setCurrentPage(1)
                                    setFilters((prevFilters) => {
                                        // Mevcut slug değerlerini al
                                        const currentSlugs = prevFilters.yayinevi_slug || []

                                        // Gelen slug değerlerini kontrol et ve güncelle
                                        const updatedSlugs = selectedYayineviSlugs.reduce((acc, slug) => {
                                            if (currentSlugs.includes(slug)) {
                                                // Eğer mevcutta varsa, çıkar
                                                return acc.filter((existingSlug) => existingSlug !== slug)
                                            } else {
                                                // Eğer mevcutta yoksa, ekle
                                                return [...acc, slug]
                                            }
                                        }, currentSlugs)
                                        setCheckedYayineviKeys(updatedSlugs as React.Key[])
                                        return {
                                            ...prevFilters,
                                            yayinevi_slug: updatedSlugs,
                                            sayfa: 0,
                                        }
                                    })
                                }}
                            />
                            <OkulyonetimOtherFilter
                                title="Sınıf Seviyesi"
                                searchbar={false}
                                checkedTempKeys={checkedSinifKeys.map((key) => key.toString())}
                                options={
                                    data?.okul?.okulyonetimUrunler?.siniflar
                                        ?.filter((sinif) => sinif !== null && sinif?.sinif_count > 0)
                                        ?.map((sinif) => ({
                                            title: sinif?.isim || 'Bilinmeyen',
                                            count: sinif?.sinif_count,
                                            value: sinif?.sinif_slug || '', // Null değerlerden kaçının
                                            isSelected: false,
                                        })) || []
                                }
                                onChange={(selectedSinifSlugs) => {
                                    setCurrentPage(1)
                                    setFilters((prevFilters) => {
                                        // Mevcut slug değerlerini al
                                        const currentSlugs = prevFilters.sinif_slug || []

                                        // Gelen slug değerlerini kontrol et ve güncelle
                                        const updatedSlugs = selectedSinifSlugs.reduce((acc, slug) => {
                                            if (currentSlugs.includes(slug)) {
                                                // Eğer mevcutta varsa, çıkar
                                                return acc.filter((existingSlug) => existingSlug !== slug)
                                            } else {
                                                // Eğer mevcutta yoksa, ekle
                                                return [...acc, slug]
                                            }
                                        }, currentSlugs)
                                        setCheckedSinifKeys(updatedSlugs as React.Key[])
                                        return {
                                            ...prevFilters,
                                            sinif_slug: updatedSlugs,
                                            sayfa: 0,
                                        }
                                    })
                                }}
                            />
                            <OkulyonetimOtherFilter
                                title="Ders"
                                searchbar={false}
                                checkedTempKeys={checkedDersKeys.map((key) => key.toString())}
                                options={
                                    data?.okul?.okulyonetimUrunler?.dersler
                                        ?.filter((ders) => ders !== null && ders?.ders_count > 0)
                                        ?.map((ders) => ({
                                            title: ders?.isim || 'Bilinmeyen',
                                            count: ders?.ders_count,
                                            value: ders?.ders_slug || '', // Null değerlerden kaçının
                                            isSelected: false,
                                        })) || []
                                }
                                onChange={(selectedDersSlugs) => {
                                    setCurrentPage(1)
                                    setFilters((prevFilters) => {
                                        // Mevcut slug değerlerini al
                                        const currentSlugs = prevFilters.ders_slug || []

                                        // Gelen slug değerlerini kontrol et ve güncelle
                                        const updatedSlugs = selectedDersSlugs.reduce((acc, slug) => {
                                            if (currentSlugs.includes(slug)) {
                                                // Eğer mevcutta varsa, çıkar
                                                return acc.filter((existingSlug) => existingSlug !== slug)
                                            } else {
                                                // Eğer mevcutta yoksa, ekle
                                                return [...acc, slug]
                                            }
                                        }, currentSlugs)
                                        setCheckedDersKeys(updatedSlugs as React.Key[])
                                        return {
                                            ...prevFilters,
                                            ders_slug: updatedSlugs,
                                            sayfa: 0,
                                        }
                                    })
                                }}
                            />
                        </div>
                    )}
                </Col>
                <Col xs={24} lg={18}>
                    <div className="okulyonetim-etiket-btn">
                        <Row justify="space-between" align="middle">
                            <Col>
                              <span className="okulyonetim-not-found-text">
                                🎯 <strong>Aradığınızı bulamadınız mı?</strong> <span className="highlight">Bize yazın!</span>
                              </span>
                            </Col>
                            <Col>
                                <Button onClick={() => setOpen(true)} type="primary" size="large">
                                    Talep Aç
                                </Button>
                            </Col>
                        </Row>
                    </div>

                    <Modal
                        title=""
                        centered
                        open={open}
                        onOk={() => modalOnOk()}
                        onCancel={() => modalHandleCancel()}
                    >
                        <div className="okulyonetim-not-found-product-modal">
                            <Form form={form} layout="vertical">
                                <Row gutter={10}>
                                    <Col span={24}>
                                        <Form.Item
                                            name="description"
                                            label="Talep Detayı"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Lütfen açıklama giriniz!',
                                                },
                                            ]}
                                        >
                                            <TextArea rows={8}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Modal>
                    <Row className="okulyonetim-product-list-row" gutter={[12, 12]} wrap={true}>
                        {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.map((product, index) => (
                            <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                <OkulyonetimProduct
                                    image={product?.urun?.resim ? product.urun.resim : product?.urun?.resim_url!}
                                    title={product?.urun?.isim!}
                                    pdf_url={product?.urun?.pdf_url}
                                    pdf={product?.urun?.pdf}
                                    id={product?.urun?.id ? product.urun.id : 1}
                                    mufredat={product?.urun?.mufredat ? product.urun.mufredat : false}
                                    oneri={product?.urun?.oneri ? product.urun.oneri : false}
                                    price={product?.urun?.etiket_fiyati!}
                                    quantity={1}
                                    initialIsFavori={product?.urun?.is_favori ? product.urun.is_favori : false}
                                />
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
            <Pagination
                current={currentPage}
                pageSize={20}
                total={data?.okul?.okulyonetimUrunler?.toplam_urun_sayisi!}
                onChange={handlePageChange}
                style={{marginTop: 16, textAlign: 'center'}}
                showSizeChanger={false}
            />
        </div>
    )
}

export default Search
